import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=0e02f54b&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=ts"
export * from "./UploadFile.vue?vue&type=script&lang=ts"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=0e02f54b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e02f54b",
  null
  
)

export default component.exports